import { EducationalPathItemDTO } from '../../dto/educational-path/educational-path-item.dto';

export class EducationalPathItem implements EducationalPathItemDTO {
    constructor(
        public item_id: number,
        public guid: string,
        public name: string,
        public type: string,
        public optional: boolean,
        public description: string | null,
        public created_at: string | null,
        public updated_at: string | null
    ) {}

    static fromDTO(dto: EducationalPathItemDTO): EducationalPathItem {
        return new EducationalPathItem(
            dto.item_id,
            dto.guid,
            dto.name,
            dto.type,
            dto.optional,
            dto.description,
            dto.created_at,
            dto.updated_at
        );
    }

    toDTO(): EducationalPathItemDTO {
        return {
            item_id: this.item_id,
            guid: this.guid,
            name: this.name,
            type: this.type,
            optional: this.optional,
            description: this.description,
            created_at: this.created_at,
            updated_at: this.updated_at
        };
    }
} 